import moment from 'moment';
import { getDiscountCodeRestrictions } from '../../utility/comparator';

export default ngModule => {
  ngModule.controller('ComparatorStep3CtrlSPS', function (
      AonApplicationService,
      AonConfig,
      $log,
      $sce,
      $scope) {

    let ctrl = $scope.$parent.ctrl;
    const iframe = _.get(AonApplicationService.product.fund, 'api.iframe', '');
    this.iframeSource = $sce.trustAsResourceUrl(iframe);
    this.iframeMessage = null;
    this.iframeError = null;
    this.iframeLastResponse = null;
    this.iframeLoading = false;

    this.changePaymentMethod = () => {
      this.iframeLoading = true;
    };

    let onIframeMessage = (event) => {
      const iframeOrigin = iframe.match(/(https?:\/\/.*?)\//)[1];
      if (event.origin === iframeOrigin) {
        $scope.$apply(() => {
          processIframeResponse(JSON.parse(event.data));
        });
      }
    };

    const haveCreditCardDetails = () => {
      const token = _.get(ctrl.application, 'payment.credit_card.token');
      const number = _.get(ctrl.application, 'payment.credit_card.number');
      const expiry = _.get(ctrl.application, 'payment.credit_card.expiry');
      return !!token && !!number && !!expiry;
    };

    const processIframeResponse = (data) => {
      this.iframeLastResponse = data;
      const success = data.Status === 'Success';
      if (!success) {
        this.iframeMessage = data.Message;
        this.iframeError = true;
        return;
      }

      const token = _.get(data, 'CardInfo.Token');
      const number = _.get(data, 'CardInfo.CardNo');
      const expiry = _.get(data, 'CardInfo.ExpiryDate');
      _.set(ctrl.application, 'payment.credit_card.token', token);
      _.set(ctrl.application, 'payment.credit_card.number', number);
      _.set(ctrl.application, 'payment.credit_card.expiry', expiry);

      if (haveCreditCardDetails()) {
        this.iframeMessage = 'Success: credit card was processed successfully.';
        this.iframeError = false;
      } else {
        this.iframeMessage = 'Error: credit card was not processed successfully.';
        this.iframeError = true;
      }
    };

    const realSubmit = ctrl.onSubmit;

    const isPaymentTypeDirectDebit = () => ctrl.application.payment.type == 2;
    this.isPaymentTypeDirectDebit = isPaymentTypeDirectDebit;

    ctrl.onSubmit = function(form, forceNoValidation=false) {
      if (ctrl.application.payment.type == 0 && haveCreditCardDetails()) {
        realSubmit.call(ctrl, form, forceNoValidation);
      } else if (isPaymentTypeDirectDebit()) {
        realSubmit.call(ctrl, form, forceNoValidation);
      } else {
        console.log("Error", form);
      }
    };

    this.iframeLoaded = () => {
      $scope.$apply(() => {
        this.iframeLoading = false;
      });

      const iframe = $(".payment-iframe");
      if (iframe.length) {
        if (window.addEventListener) {
          window.addEventListener("message", onIframeMessage, false);
        } else if (window.attachEvent) { // IE8
          window.attachEvent("onmessage", onIframeMessage);
        }
      }
    };

    const isFriday = date => date.getDay() == 5;
    const originalDebitDateDisabled = ctrl.debitDateDisabled;
    ctrl.debitDateDisabled = (date, mode) => {
      if (ctrl.application.payment.frequency == AonConfig.jsConstants.PaymentFrequencies.Fortnightly) {
        return !isFriday(date);
      }
      return originalDebitDateDisabled(date, mode);
    };

    this.debitDayOptions = _.range(1, 29);
    this.showDebitDaySelect = () => {
      return ctrl.fieldsets.payment.debit_day_frequencies.includes(ctrl.application.payment.frequency);
    };

    this.updateDebitDateOptions = () => {
      // Payment should be the next two fridays on or after the join date, so long as
      // the first of those fridays is at least 1 day after the current date (e.g. its
      // fine to have payment on the friday if joining on the thursday, but joining on
      // friday means first payment is the next friday).
      const today = moment();
      const joinDate = moment(_.get(ctrl.application, 'payment.join_date', moment()));
      const firstFriday = moment(joinDate).isoWeekday('Friday');
      if (firstFriday.isBefore(joinDate)) {
        firstFriday.add(1, 'weeks');
      }
      // The Math.round is needed as moment truncates e.g. 1.9999 to 1. The current version
      // of moment js doesn't seem to have this issue, but our version will truncate.
      if (Math.round(firstFriday.diff(today, 'days', true)) < 1) {
        firstFriday.add(1, 'weeks');
      }
      const secondFriday = moment(firstFriday);
      secondFriday.add(1, 'weeks');

      this.debitDateOptions = [
        firstFriday,
        secondFriday,
      ].map(date => [
        date,
        date.format('ddd DD/MM/YYYY'),
      ]);
    };
    this.updateDebitDateOptions();

    $scope.$watch('ctrl.application.payment.join_date', this.updateDebitDateOptions);

    // If a discount code has been selected, and the code restricts the payment frequencies
    // allowed, then limit the debit day options
    $scope.$watch('ctrl.application.policy.discount_code', (code) => {
      const restrictions = getDiscountCodeRestrictions(code);
      if (restrictions) {
        this.debitDayOptions = [1];
      }
    });

    this.showConditionalFields = (section, checkValid = false) => {
      const isCovered = _.get(ctrl.application, 'policy.is_covered_by_policy');
      const medicareCardType = _.get(ctrl.application, 'policy.medicare.card_type');
      const isRebate = _.get(ctrl.application, 'policy.federal_rebate');
      const allEligible = _.get(ctrl.application, 'policy.medicare.all_members_eligible');

      const isCoveredValid = !isRebate || (isCovered === true);
      const medicateCardTypeValid = !isRebate || (['green', 'blue'].includes(medicareCardType));
      // For all-eligible, we want to show the remaining form sections, but not allow
      // them to click 'Next' (it's not a valid state if they haven't answered the
      // question, but the remaining form items should still show)
      const allEligibleValid = checkValid ? (!isRebate || (allEligible === true)) : allEligible !== false;

      return {
        rebate: isCoveredValid,
        medicare: isCoveredValid && medicateCardTypeValid,
        payment: isCoveredValid && medicateCardTypeValid && allEligibleValid,
      }[section];
    };

    // If the corporate has defined it's own application page, set some default values
    if (AonConfig.corporate.apply_page_template === 'apply.sps.corporate') {
      const isRebate = _.get(ctrl.application, 'policy.federal_rebate');
      if (isRebate) {
        _.set(ctrl.application, 'policy.is_covered_by_policy', true);
        _.set(ctrl.application, 'policy.medicare.card_type', 'green');
      }

      _.set(ctrl.application, 'payment.type', 2);
      _.set(ctrl.application, 'payment.benefits_same_account', true);
      _.set(ctrl.application, 'contact.phone', _.get(ctrl.application, 'contact.phone_mobile'));

      // Override the default application valid check to disable the next button
      ctrl.applicationValid = () => this.showConditionalFields('payment', true);
    }

  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-sps.js